import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import createSagaMiddleware from 'redux-saga'
import { configureStore } from '@reduxjs/toolkit'
import { Provider } from 'react-redux'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reducer from './redux-saga/User/Reducer'
import rootSaga from './redux-saga/User/Saga'

const sagaMiddleware = createSagaMiddleware()
const sagaMiddlewareForAdmin = createSagaMiddleware()

const store = configureStore({
  reducer,
  middleware: [ sagaMiddleware, sagaMiddlewareForAdmin ],
})

sagaMiddleware.run(rootSaga)

ReactDOM.render(
  <BrowserRouter>
    <Provider store={ store }>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'),
)

// reportWebVitals()
serviceWorkerRegistration.register()
